<template>
    <svg version="1.1" id="credits_hide_button" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="37px" height="9px" viewBox="0 0 37 9" style="enable-background:new 0 0 37 9;" xml:space="preserve">
	<polygon fill="#FFFFFF" points="37,1.174 35.826,0 31.324,4.5 35.826,9 37,7.826 33.673,4.5 	"/>
        <path fill="#FFFFFF" d="M7.24,0.139H5.756c-0.136,0-0.235,0.111-0.235,0.236v3.141H1.958V0.375c0-0.125-0.101-0.236-0.238-0.236H0.237
		C0.111,0.139,0,0.25,0,0.375v8.249c0,0.124,0.111,0.237,0.237,0.237H1.72c0.138,0,0.238-0.113,0.238-0.237V5.347h3.562v3.277
		c0,0.124,0.1,0.237,0.235,0.237H7.24c0.125,0,0.237-0.113,0.237-0.237V0.375C7.478,0.25,7.365,0.139,7.24,0.139z"/>
        <path fill="#FFFFFF" d="M11.358,0.139H9.862c-0.125,0-0.237,0.111-0.237,0.236v8.249c0,0.124,0.112,0.237,0.237,0.237h1.496
		c0.123,0,0.234-0.113,0.234-0.237V0.375C11.593,0.25,11.481,0.139,11.358,0.139z"/>
        <path fill="#FFFFFF" d="M17.004,0.139h-3.041c-0.123,0-0.224,0.111-0.224,0.236v8.249c0,0.124,0.101,0.237,0.224,0.237h3.041
		c2.405,0,4.373-1.957,4.373-4.375C21.377,2.096,19.409,0.139,17.004,0.139z M16.88,7.017h-1.196V1.971h1.196
		c1.408,0,2.431,1.108,2.431,2.516C19.311,5.908,18.288,7.017,16.88,7.017z"/>
        <path fill="#FFFFFF" d="M28.298,0.139H23.14c-0.137,0-0.236,0.111-0.236,0.236v8.249c0,0.124,0.1,0.237,0.236,0.237h5.158
		c0.139,0,0.237-0.113,0.237-0.237V7.266c0-0.125-0.099-0.236-0.237-0.236h-3.451V5.347h2.842c0.124,0,0.237-0.099,0.237-0.235
		V3.752c0-0.125-0.113-0.236-0.237-0.236h-2.842V1.971h3.451c0.139,0,0.237-0.112,0.237-0.238V0.375
		C28.535,0.25,28.437,0.139,28.298,0.139z"/>
</svg>

</template>


<script>
    export default {}
</script>
